// src/components/navbar/utils/navbarUtils.js

function flattenClasses(values) {
  return values.reduce((result, value) => {
    if (Array.isArray(value)) {
      return [...result, ...flattenClasses(value)];
    }

    return value ? [...result, value] : result;
  }, []);
}

export function cn(...values) {
  return flattenClasses(values).join(" ");
}

export function isExternalUrl(url = "") {
  return /^https?:\/\//i.test(url);
}

export function getDocumentScrollTop() {
  if (typeof window === "undefined") return 0;

  return Math.max(
    window.scrollY || 0,
    document.documentElement?.scrollTop || 0,
    document.body?.scrollTop || 0,
  );
}